import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { media } from '~src/styles/media-templates';
import { ExitIcon } from '~src/shared/sidebar/styles/sidebar.sc';

export const TongueContainer = styled.div`
  display: none;
  ${media.phone`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 183px;
    margin-bottom: -153px;
    width: 100%;
  `}
`;

export const TongueWrapper = styled.div<{ $toggled: boolean }>`
  overflow: hidden;
  bottom: 0;
  height: ${({ $toggled }) => ($toggled ? '183px' : '50px')};
  transition: ${({ $toggled }) => (!$toggled ? 'all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86)' : 'none')};
  width: 100%;
  padding-top: ${({ $toggled }) => ($toggled ? '0' : '20px')};
`;

export const TongueTrigger = styled.div`
  height: 30px;
  width: 45px;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 0 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

export const TongueContent = styled.div`
  background-color: ${({ theme }) => theme.black.a3};
  height: fit-content;
  width: 100%;
`;

export const InfoItems = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LogoutButton = styled(Link)`
  display: none;
  flex-direction: row;
  font-size: 12px;
  letter-spacing: 0.2px;
  justify-content: space-evenly;
  color: rgba(255, 255, 255, 0.3);
  width: fit-content;
  ${media.phone`
    display: flex;
  `}
`;

export const LogOutIcon = styled(ExitIcon)`
  height: 25px;
  width: 25px;
`;

export const LogOutText = styled.span`
  margin-left: 10px;
`;

export const ContentWrapper = styled.div`
  height: 153px;
  padding: 15px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
